import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonUtility } from '@app/_modules/commonUtility';
import { CategoryService } from '@app/_services/category.service';
import { retryWhen } from 'rxjs/operators';

@Component({
  selector: 'app-fee-details',
  templateUrl: './fee-details.component.html'
})
export class FeeDetailsComponent implements OnInit {

  form: FormGroup;
  JSON;
  isgPay_url:string;
  todayDate:Date;

  @ViewChild('txnForm') txnForm: any;
  tranxnForm : FormGroup;
  submitBtnMsg:String;
  submitBtnMsgClass:String = 'wrappper';
  commonUtility:CommonUtility;
  loading = false;
  name:any='';
  fathersName:any='';
  courseLoader = false;
  course:any;
  amount:any;
  semester:any;
  semesterList:any;
  source:any;
  type:any='';
  row:any='';
  disableSelect;
  totalFees:any;
  EncDataField:string;
  MerchantIdField:string;
  TransactionId:string;
  BankIdField:string;
  TerminalIdField:string;
  VersionField:string;
  myDIV: Boolean = false ;
  totalDisabled:boolean=true;
  feesTypeList:string[] = ['Course Fee','Exam Fee','Both','Other'];
  fetchFeesType:any;
  fetchFee:any;
  courseList:string[] = ['CCNA / RHCSA / RHCE','AWS / Azure','DevOps / Openshift / CKA', 'Data Analytics & ML', 'Cyber Security - PENT','Python',' Software - Others','Cloud & DevOps - Internship','Cloud & Cyber Security - Internship','Data Analytics, ML & AI - Internship','Digital Marketing - Internship',' Software - Internship','Others'];
  selectedCourse: string = "";
  isOtherSelected: boolean = false;
  otherValue: string = "";
  captcha:any;
  initialCap: any;
  submitted = false;
  


  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private categoryService: CategoryService
  ) {
    this.JSON=JSON;
    this.isgPay_url = categoryService.isgPay_url;
    this.commonUtility = this.categoryService.commonUtility;

   }
  
  ngOnInit(): void {
   
    this.todayDate = new Date();
  this.tranxnForm = this.formBuilder.group({
    Version:[''],
    TerminalId: [''],
    BankId: [''],
    MerchantId: [''],
    EncData:[''],
    TransactionId:['']

         });
      this.form = this.formBuilder.group({
        fullName: ["",[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]],
        mobileNo: ["",[Validators.required,Validators.pattern("[1-9][0-9]{9}$")]],
        emailId: ["",[Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9]+\\.[a-z]{2,4}$")]],
        address: ["",[Validators.required]],
        course: ["",[Validators.required]],
        // specifyOther: ["",[Validators.required]],
        specifyOther: [""],
        feesType: ["",[Validators.required]],
        contactedPerson: ["",[Validators.pattern("^[a-zA-Z ]+$")]],
        comments: [""],
        amount: ["",[Validators.required,Validators.pattern("^[0-9]*$")]],  
        captcha: ["", [Validators.required]]

      });
      this.Cap();
  }

  ValidCaptcha(){
    let str1=this.initialCap
    let str2=this.form.get('captcha').value;
    if(str2.toUpperCase()!="") {
    if(str1 == str2.toUpperCase()){
      this.form.controls['captcha'].setErrors(null);
      return true;
    }else{
      this.form.controls['captcha'].setErrors({'incorrectcaptcha': true});
      return false;
    }
    }
    else {
      this.commonUtility.alertMsg('Please try again invalid Captcha','',false);
    }
  }

  Cap() {
    let alpha = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
     var apl1 = alpha[Math.floor(Math.random() * 36)];
     var apl2 = alpha[Math.floor(Math.random() * 36)];
     var apl3 = alpha[Math.floor(Math.random() * 36)];
     var apl4 = alpha[Math.floor(Math.random() * 36)];
     var apl5 = alpha[Math.floor(Math.random() * 36)];
     var apl6 = alpha[Math.floor(Math.random() * 36)];
     this.initialCap = apl1 + apl2 + apl3 + apl4 + apl5 + apl6;

    }
  
  courseType(event){
    console.log(event.value);
    
    if(event.value == 'Others'){
      this.form['controls']['specifyOther'].setValidators([Validators.required]);
    }
  }

  get f()
 { return this.form.controls; }

  Submit():void{
    var routeUrl;
    this.submitted = true;

    if(this.form.controls.amount.value == 0){
      this.commonUtility.alertMsg('Amount Should Not be Zero , Please Enter the Fee Amount','',false);
    }else{
      if (this.form.invalid || (!this.ValidCaptcha()) ) {
      return; 
    }
 
    let req = {
      'fullName': this.form.controls.fullName.value,
      'mobileNo': this.form.controls.mobileNo.value,
      'emailId': this.form.controls.emailId.value,
      'address': this.form.controls.address.value,
      'course': this.form.controls.course.value,
      'specifyOther': this.form.controls.specifyOther.value,
      'feesType': this.form.controls.feesType.value,
      'contactedPerson': this.form.controls.contactedPerson.value,
      'comments': this.form.controls.comments.value,
      'amount': this.form.controls.amount.value,
      'captcha': this.form.controls.captcha.value,
      'source': 'IPSR'
    }


   // console.log("req : ");
    const encodedCaptcha = btoa(this.form.controls.captcha.value);
     //console.log("Encoded CAPTCHA--",encodedCaptcha);     
      //console.log("On Submit Req-------",req);
    routeUrl = 'payment/pay-details';
    this.categoryService.submitIpsrDetails(req,encodedCaptcha).subscribe(res =>  {
      if(res.body.statusCode === "00000")
      {
       this.tranxnForm.controls.EncData.setValue(res.body.data.fields.EncData);
       this.tranxnForm.controls.MerchantId.setValue(res.body.data.fields.MerchantId);
       this.tranxnForm.controls.BankId.setValue(res.body.data.fields.BankId);
       this.tranxnForm.controls.TerminalId.setValue(res.body.data.fields.TerminalId);
       this.tranxnForm.controls.Version.setValue(res.body.data.fields.Version);
       this.tranxnForm.controls.TransactionId.setValue(res.body.data.fields.TransactionId);

       this.EncDataField  	= res.body.data.fields.EncData;
       this.MerchantIdField = res.body.data.fields.MerchantId;
       this.BankIdField = res.body.data.fields.BankId;
       this.TerminalIdField = res.body.data.fields.TerminalId ;
       this.VersionField = res.body.data.fields.Version ;
       this.txnForm.nativeElement.submit();


      }
      else{
       this.commonUtility.alertMsg(res.body.statusDesc,'',false);
      }
      this.Cap();
       this.loading = false;
            },(error)=>{
              this.Cap();
              this.commonUtility.alertMsg(JSON.stringify(error.statusText) ,'',false);}
      )
     }
    }

    //  changeFeeType(){

    //   this.fetchFeesType='';

    //   //this.fetchFeesType = this.form.get('feesType')?.value.toString();
    //   this.fetchFeesType = this.form.controls['feesType'].value;
    //   this.form.controls['feeTypeLable'].setValue(this.fetchFeesType);
    //   console.log("LABLE---");
    //   console.log(this.form.controls['feeTypeLable'].value);
    // }

    // fetchFeeAmount(){

    //    this.fetchFee='';

    //    this.fetchFee=this.form.controls['fee'].value;
    //    this.form.controls['feeLable'].setValue(this.fetchFee);

    // }

    // onCourseChange(){
    //   if(this.form.controls.course.value === "Others"){
    //     console.log("Course Value",this.form.controls.course.value);
    //     //this.isOtherSelected = 
    //     this.isOtherSelected=true;
    //   }
   
    // }



  onSubmit(): void
{

}
hideError(controlName:any)
    {
      this.form.controls[controlName].markAsUntouched();
      if(this.submitBtnMsgClass && this.submitBtnMsgClass.indexOf("alertBlock")>-1)
      {  this.submitBtnMsgClass="wrapper"; }
      if(this.submitBtnMsg && this.submitBtnMsg.indexOf("a")>-1)
      { this.submitBtnMsg=""; }

    }



}
